import { apiGrupoObtenerGruposInfoV2, apiGrupoObtenerHorario, apiGrupoObtenerMaestrosInfo } from "../API";
import { _APP_DATA } from "../AppData";
import { IApiResult, IGrupoInfo, IInfoTeacher, ISchoolHour } from "../models/Entities";
import { RequestData } from "../utils/RequestData";

export const _GRUPOSINFO_MAP = new Map<number, IGrupoInfo>();


/** Mapa para almacenar las promesas de obtención de información de grupos mientras existan */
const GRUPO_PROMISES_MAP = new Map<number, Promise<any>>();

/**
 * Obtiene la información de los grupos por sus ids
 * y los agrega al diccionario {@link _GRUPOSINFO_MAP} solo si no existen previamente.
 *
 * @param idsGrupos Array de ids de los grupos a obtener
 * @returns Promise que se resuelve con el diccionario actualizado {@link _GRUPOSINFO_MAP}
 */
export function _SvGrupoObtenerGruposInfo(idsGrupos: number[]): Promise<Map<number, IGrupoInfo>> {
    // Verificar si ya existe una promesa para alguno de los ids de grupo
    const existingPromises = idsGrupos.map(id => GRUPO_PROMISES_MAP.get(id)).filter(p => p !== undefined);
    if (existingPromises.length > 0) {
        // Esperar promesas existentes y obtener grupos faltantes
        return Promise.all(existingPromises).then(() => {
            const remainingIds = idsGrupos.filter(id => !_GRUPOSINFO_MAP.has(id));
            if (remainingIds.length === 0) {
                return _GRUPOSINFO_MAP;
            } else {
                return _SvGrupoObtenerGruposInfo(remainingIds);
            }
        });
    }

    const params = {
        Ids: idsGrupos,
    }
    const promise = new Promise<typeof _GRUPOSINFO_MAP>(resolve => {
        new RequestData<IApiResult<IGrupoInfo[]>>(apiGrupoObtenerGruposInfoV2)
            .Params(params)
            .Completion((response, error) => {
                const resultData: IGrupoInfo[] = response.Datos || [];
                if (error) {
                    console.log(error.name, error.message);
                }
                resultData.forEach(d => {
                    _GRUPOSINFO_MAP.set(d.IdGrupo, d);
                });
                resolve(_GRUPOSINFO_MAP);
            })
            .Get();
    });

    idsGrupos.forEach(id => {
        if (!GRUPO_PROMISES_MAP.has(id)) {
            GRUPO_PROMISES_MAP.set(id, promise);
        }
    });

    promise.finally(() => {
        idsGrupos.forEach(id => {
            GRUPO_PROMISES_MAP.delete(id);
        });
    });

    return promise;
}

export const _GRUPO_MAESTROSINFO_MAP: Map<number, IInfoTeacher> = new Map();
let maxDateTeacherInfo: string | null = null;
export function _SvGrupoObtenerMaestrosInfo(callback?: (data: Array<IInfoTeacher>) => void) {
    const params = {
        IdGrupo: _APP_DATA.userData.IdGrupo,
        Modificacion: maxDateTeacherInfo
    }

    new RequestData<IApiResult<IInfoTeacher[]>>(apiGrupoObtenerMaestrosInfo)
        .Params(params)
        .Completion((response, error) => {
            let resultData = response?.Datos || [];
            if (error)
                console.log(error.name, error.message);
            resultData.forEach(item => {
                _GRUPO_MAESTROSINFO_MAP.set(item.IdTeacher, item);
            })

            let maxDate = response?.Maxima || null;
            if (resultData.length > 0 && maxDate != null)
                maxDateTeacherInfo = maxDate;
            if (resultData.length > 0 && callback) callback(resultData);
        }).Get()
}

export function _SvGrupoClearMaestrosInfoData() {
    _GRUPO_MAESTROSINFO_MAP.clear();
    maxDateTeacherInfo = null;
}

export const _GRUPO_HORARIOS_ALUMNOS_MAP: Map<number, ISchoolHour> = new Map();
export let maxDateSchedule: string | null = null;

export function _SvGrupoObtenerHorario(callback: (resul: Array<ISchoolHour>) => void) {
    let day: number = new Date().getDay();
    day = day > 0 ? day - 1 : 6;

    let params = {
        Dia: day,
        IdGrupo: _APP_DATA.userData.IdGrupo,
        Modificacion: maxDateSchedule
    };

    new RequestData<IApiResult<ISchoolHour[]>>(apiGrupoObtenerHorario)
        .Params(params)
        .Completion((response, error) => {
            let resultData = response ? response.Datos : [];
            // let status = response ? response.Estado : -111;
            if (error)
                console.log(error.name, error.message);

            resultData.forEach(item => {
                let obj = Object.assign({}, item) as any;
                item.Entrada = obj.Entrada ? new Date(obj.Entrada) : null;
                item.Salida = obj.Salida ? new Date(obj.Salida) : null;

                if (!item.EnUso)
                    _GRUPO_HORARIOS_ALUMNOS_MAP.delete(item.IdAlumno);

                else
                    _GRUPO_HORARIOS_ALUMNOS_MAP.set(item.IdAlumno, item);
            });

            if (resultData.length > 0 && response)
                maxDateSchedule = response.Maxima;

            if (callback) callback(resultData);
        }).Get();
}

export function _SvGrupoClearHorarios() {
    _GRUPO_HORARIOS_ALUMNOS_MAP.clear()
    maxDateSchedule = null
}